import { render, staticRenderFns } from "./Aframe.vue?vue&type=template&id=ce17bd58"
import script from "./Aframe.vue?vue&type=script&lang=js"
export * from "./Aframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports